import { TenantEntity } from '../TenantEntity'

export class VgmContainer extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'VgmContainer'
  }
  get containerNo() {
    return this._data.containerNo
  }
  set containerNo(containerNo) {
    this._data.containerNo = containerNo
  }
  get vgmWeight() {
    return this._data.vgmWeight
  }
  set vgmWeight(vgmWeight) {
    this._data.vgmWeight = vgmWeight
  }
  get vgmWeightingMethod() {
    return this._data.vgmWeightingMethod
  }
  set vgmWeightingMethod(vgmWeightingMethod) {
    this._data.vgmWeightingMethod = vgmWeightingMethod
  }
  get vgmLiabilityCompany() {
    return this._data.vgmLiabilityCompany
  }
  set vgmLiabilityCompany(vgmLiabilityCompany) {
    this._data.vgmLiabilityCompany = vgmLiabilityCompany
  }
  get weighingAddress() {
    return this._data.weighingAddress
  }
  set weighingAddress(weighingAddress) {
    this._data.weighingAddress = weighingAddress
  }
  get vgmAutoGraph() {
    return this._data.vgmAutoGraph
  }
  set vgmAutoGraph(vgmAutoGraph) {
    this._data.vgmAutoGraph = vgmAutoGraph
  }
  get vgmInfoUuid() {
    return this._data.vgmInfoUuid
  }
  set vgmInfoUuid(vgmInfoUuid) {
    this._data.vgmInfoUuid = vgmInfoUuid
  }
  get seaHouseState() {
    return this._data.seaHouseState
  }
  set seaHouseState(seaHouseState) {
    this._data.seaHouseState = seaHouseState
  }
}
